import Emoji1 from "../SVGs/Emoji1";
import Emoji2 from "../SVGs/Emoji2";
import Emoji3 from "../SVGs/Emoji3";
import Emoji4 from "../SVGs/Emoji4";
import Emoji5 from "../SVGs/Emoji5";
import Emoji6 from "../SVGs/Emoji6";
import Emoji7 from "../SVGs/Emoji7";
import Emoji8 from "../SVGs/Emoji8";
import Emoji9 from "../SVGs/Emoji9";

const postReacts = {
  3: { emoji: <Emoji1 />, name: "Cry" },
  4: { emoji: <Emoji2 />, name: "LOL" },
  5: { emoji: <Emoji3 />, name: "Angry" },
  6: { emoji: <Emoji4 />, name: "Wondering" },
  7: { emoji: <Emoji5 />, name: "Love" },
  8: { emoji: <Emoji6 />, name: "Crazy" },
  9: { emoji: <Emoji8 />, name: "Disgusted" },
  2: { emoji: <Emoji7 />, name: "Embarrassed" },
  1: { emoji: <Emoji9 />, name: "Like" },
};
const reactsIds = [3, 4, 5, 6, 7, 8, 9, 2, 1];
export { postReacts, reactsIds };
